import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Flame } from "lucide-react";

/**
 * Streak chip — reads from GET /api/profile/activity and counts consecutive
 * non-zero UTC days ending today. Renders nothing if streak < 1.
 * At milestones (7, 30, 90, 365) the chip glows.
 */
export default function StreakChip() {
  const [streak, setStreak] = useState(0);
  const [longest, setLongest] = useState(0);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get("/profile/activity");
        const days = data?.days || [];
        // count trailing streak
        let cur = 0;
        for (let i = days.length - 1; i >= 0; i--) {
          if ((days[i].count || 0) > 0) cur++;
          else break;
        }
        // longest
        let best = 0; let run = 0;
        days.forEach((d) => {
          if ((d.count || 0) > 0) { run++; if (run > best) best = run; }
          else run = 0;
        });
        if (mounted) { setStreak(cur); setLongest(best); }
      } catch {}
    })();
    return () => { mounted = false; };
  }, []);

  if (streak < 1) return null;

  const milestone = streak >= 365 ? "year" : streak >= 90 ? "quarter" : streak >= 30 ? "month" : streak >= 7 ? "week" : null;

  return (
    <div
      className={`inline-flex items-center gap-2 border px-3 h-9 font-mono-num text-[11px] uppercase tracking-widest ${
        milestone ? "border-[#0D9488] bg-[#0D9488]/10 text-[#0D9488]" : "border-slate-200 text-slate-800"
      }`}
      title={`Longest streak: ${longest} days`}
      data-testid="streak-chip"
      style={milestone ? { boxShadow: "0 0 24px -8px #0D9488" } : undefined}
    >
      <Flame className={`w-3.5 h-3.5 ${milestone ? "text-[#0D9488]" : "text-slate-500"}`} />
      <span>{streak}-day streak</span>
      {milestone && <span className="text-black bg-[#0D9488] px-1.5 py-0.5">🔥 {milestone}</span>}
    </div>
  );
}
